<script lang="ts" setup>
const AppCounter = defineAsyncComponent(
  () => import('~/components/App/AppCounter.vue'),
)

const emit = defineEmits(['addAdditive'])
defineProps({
  quantity: {
    type: Number,
    required: true,
  },
})

const addAdditive = () => emit('addAdditive')
</script>

<template>
  <app-button v-if="!quantity" class="button" @click="addAdditive">
    <app-icon name="plus-icon" size="40" />
  </app-button>

  <app-counter v-else class="button-count" v-bind="$attrs" background="#fff" />
</template>

<style lang="scss" scoped>
.button {
  width: 100%;
  background-color: $white !important;
  border-radius: 100px !important;
  box-shadow: none !important;
}

.button-count {
  width: 100%;
}
</style>
